import React from 'react'
const CTA = () => {
  return (
    <div className='cta'>
        <a href="https://api.whatsapp.com/send?phone=8801902611341" target="_blank" rel="noopener noreferrer" className='btn-consultation-gradient'>WhatsApp Contact💬</a>
        <a href="https://calendly.com/web-dev-digital-marketer/dm" target="_blank" rel="noopener noreferrer" className='btn-consultation-gradient'>Book a Free Consultation →</a>
    </div>
  )
}

export default CTA